import React from 'react';

const Alabama = () => {
  return (
    <div>
      
    </div>
  );
}

export default Alabama;
